import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { FilterIcon } from "app/icons";
import React from "react";

import { useStyles } from "./styles";

type Props<T extends string> = {
  label: string;
  value: T;
  options: T[];
  getOptionLabel: (value: T) => string;
  onChange: (value: T) => void;
};

export function FilterSelect<T extends string>({
  label,
  value,
  options,
  getOptionLabel,
  onChange,
}: Props<T>) {
  const styles = useStyles();

  const handleChange = (event: SelectChangeEvent<T>) => {
    onChange(event.target.value as T);
  };

  return (
    <FormControl size="small" className={styles.root}>
      <Select
        value={value}
        onChange={handleChange}
        displayEmpty
        className={styles.select}
        IconComponent={() => null}
        renderValue={(selected) => (
          <Box className={styles.selectValue}>
            <FilterIcon className={styles.filterIcon} />
            <span className={styles.selectText}>
              {`${label}: ${getOptionLabel(selected as T)}`}
            </span>
            <KeyboardArrowDownIcon className={styles.selectChevron} />
          </Box>
        )}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {getOptionLabel(option)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
